export default function validation(values) {
    let errors = {}
    const email_pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const password_pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/
    const phone_pattern =/^\d{10}$/
    var status = true;

    if (!values.first_name) {
        status = false;
        errors.first_name = "Please enter your name.";
    }

    if (!values.email) {
        status = false;
        errors.email = "Please enter your email address."
    }
    if (values.email && !email_pattern.test(values.email)) {
        status = false;
        errors.email = "Please enter a valid email address."
    }
    
    if (!values.phone) {
        status = false;
        errors.phone = "Please enter your phone number."
    }
    if (values.phone && !phone_pattern.test(values.phone)){
        status = false;
        errors.phone ="Please enter 10 digit phone number"
    }
    if (!values.password) {
        status = false;
        errors.password = "Please enter password."
    }
    if (!values.Confirm_password) {
        status = false;
        errors.Confirm_password = "Please enter confirm password."
    }   
    if (values.password && !password_pattern.test(values.password)) {
        status = false;
        errors.password = "password must be eight characters including one uppercase letter, one special character and alphanumeric characters"
    }

    if (values.Confirm_password && String(values.Confirm_password) !== String(values.password)) {
        status = false;
        errors.Confirm_password = "Please make sure your passwords match"
    }

    return {'errors':errors,'status':status};
}